<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <v-layout row justify-center>
      <v-dialog v-model="detaydialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar color="info" size="120px" dark>
              <v-toolbar-title class="baslikfont">{{dialog_baslik}}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-card-text>
            <v-flex pa-1 xs12 sm12 md12>
              <v-card>
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-layout wrap>
                      <div class="flex md12">
                        <div v-show="codegorunum === true ">
                          <v-text-field :label="$t('Template-ID')" :color="color" hide-details="" v-model="SablonDetay.SablonID"
                            :error-messages="errors.collect('bankakod')" v-validate="'required'" data-vv-name="bankakod"
                            required>
                          </v-text-field>
                        </div>

                        <v-select :items="yedekalanid" clearable :label="$t('Field-ID')" v-model="SablonDetay.AlanID"
                          hide-details=""></v-select>
                        <v-text-field :label="$t('Area-Name')" :color="color" tabindex="3" hide-details=""
                          v-model="SablonDetay.AlanAdi" :error-messages="errors.collect('bankaadi')"
                          v-validate="'required'" data-vv-name="bankaadi" required>
                        </v-text-field>
                        <v-select :items="evethayir" clearable item-value="value" item-text="text" :label="$t('Compulsory')"
                          v-model="SablonDetay.Zorunlu" hide-details=""></v-select>
                        <v-select :items="evethayir" clearable item-value="value" item-text="text" :label="$t('Bill')"
                          v-model="SablonDetay.Fatura" hide-details=""></v-select>
                        <v-text-field :label="$t('Amadeus-Code')" hide-details="" v-model="SablonDetay.AmedeusKod"
                          :color="color"></v-text-field>
                        <v-text-field :label="$t('Galileo-Code')" hide-details="" :color="color"
                          v-model="SablonDetay.GalileoKod"></v-text-field>
                        <v-select :items="evethayir" clearable item-value="value" item-text="text" :label="$t('Key')"
                          v-model="SablonDetay.Anahtar" hide-details=""></v-select>
                      </div>

                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div v-show="m === true">



              <v-tooltip bottom>
                  <v-btn :disabled="!sayfayetki.Delete" color="info" slot="activator" @click="sablondetaysil()" flat> <span
                      class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t('Delete') }}</span>
                    </span>
                  </v-btn>
                  <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
                  <span v-if="sayfayetki.Delete">{{ $t('Delete') }}</span>
              </v-tooltip>

              <v-tooltip bottom>
                  <v-btn :disabled="!sayfayetki.Update" color="info" slot="activator" @click="detayguncelle()" flat> <span
                      class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t('Update') }}</span>
                    </span>
                  </v-btn>
                  <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                  <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
              </v-tooltip>



            </div>
            <v-btn color="blue darken-1" flat @click.native="detaydialog=false">{{$t('Cancel')}}</v-btn>
            <div v-show="k === true">

            <v-tooltip bottom>
                  <v-btn :disabled="!sayfayetki.Save" color="info" slot="activator" @click="detaykaydet()" flat> <span
                      class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{$t("save_button")}}</span>
                    </span>
                  </v-btn>
                  <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                  <span v-if="sayfayetki.Save">{{$t("save_button")}}</span>
              </v-tooltip>



            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogaciklama" max-width="200px">
        <v-card>
          <v-card-title>
            {{$t('Area-ID-Disclosures')}}
          </v-card-title>
          <v-card-text>

            <v-flex xs12 sm12>
              <h3> S: {{$t('Plain-Text')}}.</h3>
            </v-flex>

            <v-flex xs12 sm12>
              <h3> B: {{$t('Numeric')}} </h3>
            </v-flex>

            <v-flex xs12 sm12>
              <h3> D: {{$t('Date')}} </h3>
            </v-flex>

            <v-flex xs12 sm12>
              <h3> M: {{$t('Currency-Unit')}} </h3>
            </v-flex>

          </v-card-text>
          <v-card-actions>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="ekledialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar color="info" size="120px" dark>
              <v-toolbar-title class="baslikfont">{{dialog_baslik}}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-card-text>
            <v-container fluid="">
              <v-form ref="formcariyegore" v-model="valid" lazy-validation>
                <v-layout wrap>

                  <div class="flex md12">
                    <v-text-field :rules="[v => !!v || $t('Please-select-a-date')]" :label="$t('Template-Name')" hide-details=""
                      v-model="Sablon.ProfileName"></v-text-field>
                  </div>

                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div v-show="m === true">
              <v-btn id="bguncelle" color="blue darken-1" flat @click="guncelle()">{{ $t('Update') }}</v-btn>
            </div>
            <v-btn color="blue darken-1" flat @click="eklevazgec()">{{$t('Cancel')}}</v-btn>
            <div v-show="k === true">
              <v-btn id="bkaydet" color="blue darken-1" flat @click="profilkaydet()">{{$t("save_button")}}</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <v-toolbar color="info" size="120px" dark>
        <v-toolbar-title>{{$t('Profile-Template-Design')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field flat="" solo-inverted="" hide-details v-model="search3" :label="$t('Search')" append-icon="search">
        </v-text-field>


        <v-tooltip bottom>
          <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="ekle()" flat> <span class="hidden-sm-and-down">
              <span class="hidden-sm-and-down">Profil Şablon Ekle</span>
            </span>
            <v-icon right dark>add_box</v-icon>
          </v-btn>
          <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
          <span v-if="sayfayetki.Save">Profil Şablon Ekle</span>
        </v-tooltip>


        <v-menu offset-y>
          <v-btn slot="activator" dark icon>
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>

            <v-list-tile @click.native="dialogaciklama=true">
              <v-list-tile-title>{{$t('Area-ID-Disclosures')}}</v-list-tile-title>
            </v-list-tile>

          </v-list>
        </v-menu>



      </v-toolbar>
    </v-layout>

    <v-container fluid>
      <v-layout row wrap>

        <v-flex xs12 sm6 md6>
          <v-select :items="itemssablon" clearable item-value="ID" @change="detaygetir()" item-text="SablonAdi"
            :label="$t('Select-Template')" v-model="Sablon.TemplateID" hide-details=""></v-select>
        </v-flex>

        <v-flex xs12 v-if="detaykont">
          <v-card>
            <v-card-title>
              <v-flex>

                <v-tooltip bottom>
                  <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="detayekle()" flat> <span
                      class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t('Add-v2', { value: $t('Details')}) }}  </span>
                    </span>
                    <v-icon right dark>add_box</v-icon>
                  </v-btn>
                  <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                  <span v-if="sayfayetki.Save">{{ $t('Add-v2', { value: $t('Details')}) }}</span>
                </v-tooltip>

              </v-flex>
              <v-spacer></v-spacer>


            </v-card-title>
            <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
              :search="search3">
              <v-progress-linear slot="progress" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <tr @click="Getir(props.item.ID,props.item.AlanID)" item>
                  <td class="text-xs-left">{{ props.item.AlanID }}</td>
                  <td class="text-xs-left">{{ props.item.AlanAdi }}</td>
                  <td class="text-xs-left">{{ props.item.Zorunlu }}</td>
                  <td class="text-xs-left">{{ props.item.Fatura }}</td>
                  <td class="text-xs-left">{{ props.item.AmedeusKod }}</td>
                  <td class="text-xs-left">{{ props.item.GalileoKod }}</td>
                </tr>
              </template>
              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                {{ $t('No-records-searched-for', { value: search3}) }}
              </v-alert>
            </v-data-table>
          </v-card>
          <template>
            <v-card>
              <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
                :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'"
                v-model="snackbar">
                {{ text1 }}
                <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
              </v-snackbar>
            </v-card>
          </template>
        </v-flex>

      </v-layout>
    </v-container>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"

  export default {
    data() {
      return {
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        i: 0,
        yedekalanid: [],
        yedekalanid1: ['S1', 'S2', 'S3', 'S4', 'S5', 'S6', 'S7', 'S8', 'S9', 'S10', 'S11', 'S12', 'S13', 'S14', 'S15',
          'S16',
          'S17', 'S17', 'S18', 'S19', 'S20', 'S21', 'S22', 'S23', 'S24', 'S25', 'S26', 'S27', 'S28', 'S29', 'S30',
          'S31', 'S32', 'S33', 'S34', 'S35', 'S36', 'S37', 'S38', 'S39', 'S40', 'S41', 'S42', 'S43', 'S44', 'S45',
          'S46', 'S47', 'S48', 'S49', 'S50', 'D1', 'D2', 'D3', 'D4', 'D5', 'D6', 'D7', 'D7', 'D8', 'D9', 'D10',
          'B1', 'B2', 'B3', 'B4', 'B5', 'B6', 'B7', 'B8', 'B9', 'B10', 'M1', 'M2', 'M3', 'M4', 'M5', 'M6', 'M7', 'M8',
          'M9', 'M10'
        ],

        alanid: ['S1', 'S2', 'S3', 'S4', 'S5', 'S6', 'S7', 'S8', 'S9', 'S10', 'S11', 'S12', 'S13', 'S14', 'S15', 'S16',
          'S17', 'S17', 'S18', 'S19', 'S20', 'S21', 'S22', 'S23', 'S24', 'S25', 'S26', 'S27', 'S28', 'S29', 'S30',
          'S31', 'S32', 'S33', 'S34', 'S35', 'S36', 'S37', 'S38', 'S39', 'S40', 'S41', 'S42', 'S43', 'S44', 'S45',
          'S46', 'S47', 'S48', 'S49', 'S50', 'D1', 'D2', 'D3', 'D4', 'D5', 'D6', 'D7', 'D7', 'D8', 'D9', 'D10',
          'B1', 'B2', 'B3', 'B4', 'B5', 'B6', 'B7', 'B8', 'B9', 'B10', 'M1', 'M2', 'M3', 'M4', 'M5', 'M6', 'M7', 'M8',
          'M9', 'M10'
        ],
        valid: true,
        alanid1: [{
            value: 'S1',
            text: 'S1 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S2',
            text: 'S2 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S3',
            text: 'S3 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S4',
            text: 'S4 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S5',
            text: 'S5 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S6',
            text: 'S6 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S7',
            text: 'S7 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S8',
            text: 'S8 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S9',
            text: 'S9 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S10',
            text: 'S10 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S11',
            text: 'S11 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S12',
            text: 'S12 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S13',
            text: 'S13 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S14',
            text: 'S14 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S15',
            text: 'S15 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S16',
            text: 'S16 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S17',
            text: 'S17 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S18',
            text: 'S18 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S19',
            text: 'S19 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S20',
            text: 'S20 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S21',
            text: 'S21 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S22',
            text: 'S22 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S23',
            text: 'S23 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S24',
            text: 'S24 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S25',
            text: 'S25 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S26',
            text: 'S26 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S27',
            text: 'S27 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S28',
            text: 'S28 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S29',
            text: 'S29 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S30',
            text: 'S30 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S31',
            text: 'S31 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S32',
            text: 'S32 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S33',
            text: 'S33 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S34',
            text: 'S34 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S35',
            text: 'S35 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S36',
            text: 'S36 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S37',
            text: 'S37 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S38',
            text: 'S38 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S39',
            text: 'S39 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S40',
            text: 'S40 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S41',
            text: 'S41 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S42',
            text: 'S42 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S43',
            text: 'S43 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S44',
            text: 'S44 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S45',
            text: 'S45 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S46',
            text: 'S46 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S47',
            text: 'S47 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S48',
            text: 'S48 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S49',
            text: 'S49 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S50',
            text: 'S50 - ' + this.$t('Plain-Text')
          },
          {
            value: 'D1',
            text: 'D1 - ' + this.$t('Date')
          },
          {
            value: 'D2',
            text: 'D2 - ' + this.$t('Date')
          },
          {
            value: 'D3',
            text: 'D3 - ' + this.$t('Date')
          },
          {
            value: 'D4',
            text: 'D4 - ' + this.$t('Date')
          },
          {
            value: 'D5',
            text: 'D5 - ' + this.$t('Date')
          },
          {
            value: 'D6',
            text: 'D6 - ' + this.$t('Date')
          },
          {
            value: 'D7',
            text: 'D7 - ' + this.$t('Date')
          },
          {
            value: 'D8',
            text: 'D8 - ' + this.$t('Date')
          },
          {
            value: 'D9',
            text: 'D9 - ' + this.$t('Date')
          },
          {
            value: 'D10',
            text: 'D10 - ' + this.$t('Date')
          },
          {
            value: 'B1',
            text: 'B1 - ' + this.$t('Numeric')
          },
          {
            value: 'B2',
            text: 'B2 - ' + this.$t('Numeric')
          },
          {
            value: 'B3',
            text: 'B3 - ' + this.$t('Numeric')
          },
          {
            value: 'B4',
            text: 'B4 - ' + this.$t('Numeric')
          },
          {
            value: 'B5',
            text: 'B5 - ' + this.$t('Numeric')
          },
          {
            value: 'B6',
            text: 'B6 - ' + this.$t('Numeric')
          },
          {
            value: 'B7',
            text: 'B7 - ' + this.$t('Numeric')
          },
          {
            value: 'B8',
            text: 'B8 - ' + this.$t('Numeric')
          },
          {
            value: 'B9',
            text: 'B9 - ' + this.$t('Numeric')
          },
          {
            value: 'B10',
            text: 'B10 - ' + this.$t('Numeric')
          },
          {
            value: 'M1',
            text: 'M1 - ' + this.$t('Currency-Unit')
          },
          {
            value: 'M2',
            text: 'M2 - ' + this.$t('Currency-Unit')
          },
          {
            value: 'M3',
            text: 'M3 - ' + this.$t('Currency-Unit')
          },
          {
            value: 'M4',
            text: 'M4 - ' + this.$t('Currency-Unit')
          },
          {
            value: 'M5',
            text: 'M5 - ' + this.$t('Currency-Unit')
          },
          {
            value: 'M6',
            text: 'M6 - ' + this.$t('Currency-Unit')
          },
          {
            value: 'M7',
            text: 'M7 - ' + this.$t('Currency-Unit')
          },
          {
            value: 'M8',
            text: 'M8 - ' + this.$t('Currency-Unit')
          },
          {
            value: 'M9',
            text: 'M9 - ' + this.$t('Currency-Unit')
          },
          {
            value: 'M10',
            text: 'M10 - ' + this.$t('Currency-Unit')
          },
        ],

        evethayir: [{
            text: this.$t('Yes'),
            value: 'E'
          },

          {
            text: 'Hayır',
            value: 'H'
          }
        ],

        headers: [{
            text: 'Alan ID',
            value: 'AlanID'
          },

          {
            text: this.$t('Area-Name'),
            value: 'AlanAdi'
          },
          {
            text: this.$t('Compulsory'),
            value: 'Zorunlu'
          },
          {
            text: this.$t("Bill"),
            value: 'Fatura'
          },
          {
            text: this.$t('Amadeus-Code'),
            value: 'AmedeusKod'
          },
          {
            text: this.$t('Galileo-Code'),
            value: 'GalileoKod'
          }

        ],

        loading: false,
        color: 'orange darken-4',
        items: [],
        itemssablon: [],
        search3: '',
        search: null,
        select: [],
        detaykont: false,
        selected: '',
        m: false,
        k: false,
        detaydialog: false,
        dialogaciklama: false,
        renk1: 'info',
        ekledialog: false,
        SablonDetay: {
          ID: '',
          SablonID: '',
          AlanID: '',
          AlanAdi: '',
          Zorunlu: '',
          Fatura: '',
          AmedeusKod: '',
          GalileoKod: '',
          Anahtar: ''
        },

        Sablon: {
          ProfileName: '',
          TemplateID: '',
          DetailID: '',
          ProfileID: ''
        },

        state: [],
        dialog_baslik: '',
        codegorunum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        progress: false,
        yedekkod: '',
        dictionary: {
          custom: {

            sablon: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
          }
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    watch: {
      search(val) {
        val && this.carigetir(val)
      }
    },
    mounted() {
      this.$validator.localize('tr', this.dictionary)

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params = {
          SirketKodu: credentials.SirketKodu
        }
        this.progress = true
        this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.itemssablon = response.body
          this.progress = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          } 

        });

      }
    },
    methods: {
      Getir(v, y) {

          this.k = false
          this.m = true
          this.codegorunum = false
          this.dialog = true
          this.yedekalanid = this.yedekalanid1
          this.yedekkod = y

          this.items.forEach(element => {
            var index = this.yedekalanid.indexOf(String(element.AlanID))
            if (index > -1) {
              this.yedekalanid.splice(index, 1);
            }
          });

          this.yedekalanid.unshift(this.yedekkod)
          this.dialog_baslik = 'Müşteri Personel Bilgileri Güncelle'

          var credentials = JSON.parse(window.localStorage.getItem('credentials'));
          var params = {
            CompanyCode: credentials.SirketKodu,
            DetailID: v
          }

          this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateDetailGet', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.SablonDetay = response.body
            this.detaydialog = true

          })


      },
      ekle: ekle,
      eklevazgec: eklevazgec,
      profilkaydet: profilkaydet,
      guncelle: guncelle,
      vazgec: vazgec,
      detaygetir: detaygetir,
      detayekle: detayekle,
      detaykaydet: detaykaydet,
      sablondetaysil: sablondetaysil,
      detayguncelle: detayguncelle
    },
    beforeMount: beforeMount,
    components: {
      yetkidialog
    },
    vazgec: vazgec
  }


  function detayekle() {

    this.yedekalanid = this.alanid1

    this.items.forEach(element => {
      var index = this.yedekalanid.indexOf(String(element.AlanID))
      if (index > -1) {
        this.yedekalanid.splice(index, 1);
      }
    });

    this.detaydialog = true
    this.dialog_baslik = "Profil Şablon Detay Ekle"
    this.SablonDetay = {}
    this.SablonDetay.SablonID = this.Sablon.TemplateID
    this.codegorunum = false
    this.k = true
    this.m = false
  }

  function detaykaydet() {
    var params = this.SablonDetay
    this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateDetailAdd', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
       this.text1 = this.$t(response.body.ResponseMessage)
      this.snackbar = true
      this.snackbar = true
      this.detaydialog = false
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      var params = {
        CompanyCode: credentials.SirketKodu,
        TemplateID: this.Sablon.TemplateID
      }

      this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateDetailList', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {

        this.items = response.body
        this.detaykont = true
        this.progress = false
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.detaykont = false
          this.progress = false
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.detaykont = false
          this.progress = false
        }
      })
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.detaykont = false
        this.progress = false

      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.detaykont = false
        this.progress = false
      }
    })
  }

  function sablondetaysil() {
    if (window.confirm('Detay\'ı silmek istediğinize emin misiniz?')) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      var params = {
        DetailID: this.SablonDetay.ID,
        CompanyCode: credentials.SirketKodu
      }
      this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateDetailDelete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status) {
           this.text1 = this.$t(response.body.ResponseMessage)
          this.snackbar = true
          this.detaydialog = false
          var params1 = {
            CompanyCode: credentials.SirketKodu,
            TemplateID: this.SablonDetay.SablonID
          }

          this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateDetailList', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
            this.detaykont = true
            this.progress = false
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.detaykont = false
              this.progress = false

            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.detaykont = false
              this.progress = false
            }
          })
        }
      }, (response) => {
        if (response.status === 0) {
          this.progress = false
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.progress = false
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })
    }
  }

  function detayguncelle() {

    var params = this.SablonDetay
    this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateDetailAdd', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

       this.text1 = this.$t(response.body.ResponseMessage)
      this.snackbar = true
      this.snackbar = true
      this.detaydialog = false

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      var params = {
        CompanyCode: credentials.SirketKodu,
        TemplateID: this.Sablon.TemplateID
      }

      this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateDetailList', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {

        this.items = response.body
        this.detaykont = true
        this.progress = false

      }, (response) => {

        if (response.status === 0) {

          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.detaykont = false
          this.progress = false

        } else {

          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.detaykont = false
          this.progress = false

        }
      })
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.detaykont = false
        this.progress = false

      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.detaykont = false
        this.progress = false
      }
    })
  }

  function eklevazgec() {
    this.ekledialog = false
    this.Sablon.ProfileName = null
  }

  function vazgec() {
    this.dialog = false
    this.search = ''
  }

  function detaygetir() {
    this.yedekalanid = new Array();
    this.yedekalanid1.forEach(element => {
      this.yedekalanid.push(element)
    });


    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var params = {
      CompanyCode: credentials.SirketKodu,
      TemplateID: this.Sablon.TemplateID
    }

    this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateDetailList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.items = response.body
      this.detaykont = true
      this.progress = false

    }, (response) => {

      if (response.status === 0) {

        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.detaykont = false
        this.progress = false

      } else {

        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.detaykont = false
        this.progress = false
      }
    })
  }

  function profilkaydet() {

    if (this.$refs.formcariyegore.validate()) {


      var params = this.Sablon

      this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateAdd', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {

         this.text1 = this.$t(response.body.ResponseMessage)
        this.snackbar = true
        this.detaydialog = false

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var params1 = {
          CompanyCode: credentials.SirketKodu,
        }

        this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateList', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.itemssablon = response.body
          this.ekledialog = false
          this.detaykont = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.detaykont = false
            this.progress = false
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.detaykont = false
            this.progress = false
          }
        })
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.detaykont = false
          this.progress = false

        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.detaykont = false
          this.progress = false
        }
      })
    }


  }

  function ekle() {
    this.ekledialog = true
    this.dialog_baslik = 'Yeni Şablon Ekle'
    this.k = true
    this.m = false
    this.$validator.reset()
  }

  function beforeMount() {

  }

  function guncelle() {

    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.MusteriPersonel.SirketKodu = credentials.SirketKodu
        var params = this.MusteriPersonel
        this.codegorunum = false
        this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelAdd', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.text1 = this.$t('Update-completed')
            this.snackbar = true
            var params1 = {
              SirketKodu: credentials.SirketKodu
            }
            this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelList', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = response.statusText
                this.snackbar = true
              }
            })
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })
      }
    })
  }
</script>

<style>
</style>